// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xProductPartNumbersStyles from "@conklin/App/SharedStyles/ProductPartNumbersStyles";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

export const partNumbersStyle: { label?: TypographyProps; value?: TypographyProps } = {
    label: {
        weight: "bold",
        size: 12,
        lineHeight: "13px",
        css: css`
            flex: 0 0 auto;
            letter-spacing: 0;
            margin-right: 4px;
            padding-left: 0;
            &:after {
                content: ":";
            }
        `,
    },
    value: {
        size: 12,
        lineHeight: "13px",
        css: css`
            flex: 1 1 auto;
            letter-spacing: 0;
            min-width: 0;
            ${wrapInContainerStyles}
        `,
    },
};

productPartNumbersStyles.manufacturerItemLabelText = {
    ...xProductPartNumbersStyles.label,
};

productPartNumbersStyles.manufacturerItemValueText = {
    ...xProductPartNumbersStyles.value,
};

productPartNumbersStyles.erpNumberLabelText = {
    ...xProductPartNumbersStyles.label,
};

productPartNumbersStyles.customerNameLabelText = {
    ...xProductPartNumbersStyles.label,
};

productPartNumbersStyles.customerNameValueText = {
    ...xProductPartNumbersStyles.value,
};

productPartNumbersStyles.erpNumberValueText = {
    ...xProductPartNumbersStyles.value,
};

productPartNumbersStyles.container = {
    gap: 0,
};
